import ModelInterface from 'src/models/ModelInterface'
import {RawWikiPage, IUser} from '@/types/entity/RawWiki'
import store from '@/store/index'
import {DateTime} from 'luxon'

class WikiPage extends ModelInterface<RawWikiPage> {

  constructor (data: RawWikiPage) {
    super(data)
  }

  public getData () {
    return this.data
  }

  public getText () {
    return this.data.text
  }

  public getTitle () {
    return this.data.title
  }

  public getParent () {
    return this.data.parent
  }

  public getCt (): number {
    return this.data.ct
  }

  public getTs () {
    return this.data.ts
  }

  public getCreateDate (format: string): string {
    return DateTime.fromMillis(this.data.ct).toFormat(format ? format : 'dd.LL.yyyy hh:mm')
  }

  public getUpdateDate (format: string): string {
    return DateTime.fromMillis(this.data.ts).toFormat(format ? format : 'dd.LL.yyyy hh:mm')
  }

  public getCuser () {
    return this.data.cuser
  }

  public getMuser () {
    return this.data.muser
  }

  public getCuserFullName () {
    if (this.getCuser()) {
      return this.getUserFullName(this.getCuser())
    } else {
      return ''
    }
  }

  public getMuserFullName () {
    if (this.getMuser()) {
      return this.getUserFullName(this.getMuser())
    } else {
      return ''
    }
  }

  private getUserFullName (user: IUser) {
    let fullName = ''
    fullName += user.last_name ? user.last_name + ' ' : ''
    fullName += user.first_name ? user.first_name + ' ' : ''
    fullName += user.middle_name ? user.middle_name + ' ' : ''
    return fullName;
  }

  get title () {
    return this.getTitle();
  }

  get leaf (): boolean {
    return true;
  }

  get isNode (): boolean {
    return false;
  }
}

export default WikiPage